import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import RegistrationView from './RegistrationView/RegistrationView';
import './LoginView.css';

interface LoginViewProps {
  isLoggedIn: boolean;
  setIsLoggedIn: (value: boolean) => void;
}

const LoginView: React.FC<LoginViewProps> = ({ isLoggedIn: _isLoggedIn, setIsLoggedIn }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showingRegistration, setShowingRegistration] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const signIn = async () => {
    if (!email || !password) {
      setErrorMessage('Please enter both email and password');
      return;
    }

    setIsLoading(true);
    setErrorMessage(null);

    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      console.log('User signed in successfully:', result.user.uid);
      setIsLoggedIn(true);
    } catch (error: any) {
      console.error('Error signing in:', error.message);
      setErrorMessage(`Failed to sign in: ${error.message}`);
    }

    setIsLoading(false);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    signIn();
  };

  if (showingRegistration) {
    return (
      <RegistrationView 
        onClose={() => setShowingRegistration(false)}
        setIsLoggedIn={setIsLoggedIn}
      />
    );
  }

  return (
    <div className="login-container">
      <div className="login-form">
        <h1 className="app-title">Minnesota Strength Training</h1>
        
        <form onSubmit={handleSubmit} className="form-content">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="text-field"
            autoCapitalize="none"
            autoComplete="email"
            disabled={isLoading}
          />
          
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="text-field"
            autoComplete="current-password"
            disabled={isLoading}
          />
          
          {errorMessage && (
            <div className="error-message">
              {errorMessage}
            </div>
          )}
          
          <button
            type="submit"
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="loading-spinner"></div>
            ) : (
              'Login'
            )}
          </button>
          
          <button
            type="button"
            className="registration-button"
            onClick={() => setShowingRegistration(true)}
            disabled={isLoading}
          >
            New Registration
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginView;
